import { render, staticRenderFns } from "./ClientCharts.vue?vue&type=template&id=d15a8b08&scoped=true&"
import script from "./ClientCharts.vue?vue&type=script&lang=js&"
export * from "./ClientCharts.vue?vue&type=script&lang=js&"
import style0 from "./ClientCharts.vue?vue&type=style&index=0&id=d15a8b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a8b08",
  null
  
)

export default component.exports